/**
 * Removes diacritics from a string, replacing accented characters with their base equivalents.
 * Supports Romanian and common European diacritics.
 * @param str The input string
 * @returns The string without diacritics
 */
export function removeDiacritics(str: string): string {
    const diacriticsMap: Record<string, string> = {
        // Romanian diacritics - preserve case
        ă: 'a',
        â: 'a',
        î: 'i',
        ș: 's',
        ț: 't',
        Ă: 'A',
        Â: 'A',
        Î: 'I',
        Ș: 'S',
        Ț: 'T',
        // Common European diacritics - lowercase
        á: 'a',
        à: 'a',
        ã: 'a',
        ä: 'a',
        å: 'a',
        é: 'e',
        è: 'e',
        ê: 'e',
        ë: 'e',
        í: 'i',
        ì: 'i',
        ï: 'i',
        ó: 'o',
        ò: 'o',
        ô: 'o',
        õ: 'o',
        ö: 'o',
        ú: 'u',
        ù: 'u',
        û: 'u',
        ü: 'u',
        // Common European diacritics - uppercase (preserve case)
        Á: 'A',
        À: 'A',
        Ã: 'A',
        Ä: 'A',
        Å: 'A',
        É: 'E',
        È: 'E',
        Ê: 'E',
        Ë: 'E',
        Í: 'I',
        Ì: 'I',
        Ï: 'I',
        Ó: 'O',
        Ò: 'O',
        Ô: 'O',
        Õ: 'O',
        Ö: 'O',
        Ú: 'U',
        Ù: 'U',
        Û: 'U',
        Ü: 'U',
    };

    // Only replace characters that are in the diacriticsMap
    const diacriticsRegex = /[ăâîșțĂÂÎȘȚáàãäåéèêëíìïóòôõöúùûüÁÀÃÄÅÉÈÊËÍÌÏÓÒÔÕÖÚÙÛÜ]/g;
    // Regex matches only characters we define in the map, so fallback is unnecessary
    return str.replace(diacriticsRegex, char => diacriticsMap[char]);
}
